import React, { Fragment } from 'react'
import { Button, ButtonLink, transparentize } from 'stylist'
import styled from 'react-emotion'

const BUTTON_KIND = 'standard'

const CombinedButtonRight = styled(ButtonLink)`
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-left: 0;
  &:disabled {
    border-color: ${transparentize('slate', 0.1)};
  }
`

const CombinedButtonLeft = styled(ButtonLink)`
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: 0;
  &:disabled {
    border-color: ${transparentize('slate', 0.1)};
  }
`

const Menu = ({ data, match: { path }, onRemove }) => (
  <Fragment>
    {data ? 'Replace:' : 'Add:'}
    <CombinedButtonLeft
      marginLeft
      marginTop
      marginBottom
      to={`${path}/new`}
      kind={BUTTON_KIND}
    >
      New
    </CombinedButtonLeft>
    <CombinedButtonRight
      marginRight
      marginTop
      marginBottom
      to={`${path}/manage`}
      kind={BUTTON_KIND}
    >
      Existing
    </CombinedButtonRight>
    {data && (
      <Button
        marginRight
        marginTop
        marginBottom
        kind={BUTTON_KIND}
        onClick={onRemove}
      >
        Remove
      </Button>
    )}
  </Fragment>
)

export default Menu



// WEBPACK FOOTER //
// ./src/components/BelongsTo/Menu.js